import Vue from 'vue';
import VueRouter from 'vue-router';
import LocationTrace from '../view/LocationTrace/index.vue';
import VideoPlay from '../view/VideoPlay/index.vue';
import swiper from '../view/swiper/index.vue';
import Home from '../view/Home.vue';
import VideoPage from '../view/LocationTrace/video.vue';
import RecVideo from '../view/LocationTrace/rec_video.vue';
import Platform from '../view/Platform/index.vue';
import HomeCy from '../view/HomeCy.vue';
import BigScreenCY from '../view/BigScreenCY/index.vue';
import BigScreenCY2 from '../view/BigScreenCY/index2.vue';
import PageImg01 from '../view/PageImg01.vue';

Vue.use(VueRouter);

/**
 * 检测 ?p=cy 参数，标记 cy 模式（供目标页感知）
 * 仅在 URL 带有 ?p=cy 时执行
 */
const queryParams = new URLSearchParams(window.location.search);
if (queryParams.get('p') === 'cy') {
  sessionStorage.setItem('cy_mode', '1');
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        // npm run build: 无 redirect，默认留在 /
        // npm run build-cy: redirect 到 /home_cy
        redirect: process.env.VUE_APP_DEFAULT_ROUTE || null,
    },
    {
        path: '/index',
        name: 'index',
        component: Home
    },
    {
        path: '/location-trace',
        name: 'LocationTrace',
        component: LocationTrace
    },
    {
        path: '/video-play',
        name: 'VideoPlay',
        component: VideoPlay
    },
    {
        path: '/swiper',
        name: 'swiper',
        component: swiper
    },
    {
        path: '/test-video',
        name: 'VideoPage',
        component: VideoPage
    },
    {
        path: '/test-rec-video',
        name: 'RecVideo',
        component: RecVideo
    },
    {
        path: '/platform',
        name: 'Platform',
        component: Platform
    },
    {
        path: '/home_cy',
        name: 'HomeCy',
        component: HomeCy
    },
    {
        path: '/bigscreen_cy',
        name: 'BigScreenCY',
        component: BigScreenCY
    },
    {
        path: '/bigscreen_cy2',
        name: 'BigScreenCY2',
        component: BigScreenCY2
    },
    {
        path: '/page_img01',
        name: 'PageImg01',
        component: PageImg01
    }
    // 其他路由配置
];

const router = new VueRouter({
    mode: 'hash', // 使用 HTML5 History 模式
    routes
});

export default router;
